import { Controller } from "@hotwired/stimulus"

// Segmented control of links (the dashboard's period): a thumb slides under the current option.
// The links load a turbo frame, so the control itself stays and only its current option changes.
export default class extends Controller {
  static targets = ["thumb", "option"]

  declare readonly thumbTarget: HTMLElement
  declare readonly optionTargets: HTMLAnchorElement[]
  private _onResize = () => this._place()

  connect() {
    this._place()
    document.fonts?.ready.then(() => this._place())
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    window.removeEventListener("resize", this._onResize)
  }

  select(event: Event) {
    const chosen = event.currentTarget as HTMLAnchorElement
    this.optionTargets.forEach(option => {
      if (option === chosen) option.setAttribute("aria-current", "true")
      else option.removeAttribute("aria-current")
    })
    this._place()
  }

  _place() {
    const current = this.optionTargets.find(option => option.getAttribute("aria-current") === "true")
    if (!current) return
    this.thumbTarget.style.width = `${current.offsetWidth}px`
    this.thumbTarget.style.transform = `translateX(${current.offsetLeft}px)`
  }
}
